<template>
  <section
    class="kn-card"
    :class="{'kn-card--flush': flush, 'kn-card--muted': muted}"
  >
    <header
      v-if="title || $slots.title || $slots.actions"
      class="kn-card__header"
    >
      <div class="kn-card__title">
        <i v-if="icon" :class="icon" class="kn-card__icon"></i>
        <slot name="title">{{ title }}</slot>
        <span v-if="subtitle" class="kn-card__subtitle">{{ subtitle }}</span>
      </div>
      <div class="kn-card__actions">
        <slot name="actions"></slot>
      </div>
    </header>
    <div class="kn-card__body">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "app-card",
  props: {
    title: {type: String, default: null},
    subtitle: {type: String, default: null},
    icon: {type: String, default: null},
    flush: {type: Boolean, default: false},
    muted: {type: Boolean, default: false},
  },
}
</script>

<style lang="scss">
.kn-card {
  background-color: var(--kn-card);
  border: 1px solid var(--kn-border);
  border-radius: var(--kn-radius-card);
  box-shadow: var(--kn-shadow-card);
  color: var(--kn-text);

  &--muted {
    background-color: var(--kn-card-muted);
    box-shadow: none;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 24px 0;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 700;
  }

  &__icon {
    color: var(--kn-primary);
  }

  &__subtitle {
    font-size: 13px;
    font-weight: 400;
    color: var(--kn-text-muted);
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__body {
    padding: 20px 24px;
  }

  &--flush &__body {
    padding: 0;
  }
}
</style>
